import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { ApplicationAdapter } from 'application/application.adapter';
import { MessageConverterPort } from 'application/message/port/message-converter.port';
import { Message } from 'domain/message/message';
import { MessageOutput } from 'infrastructure/graphql/messaging/message/model/message.output';

@Injectable()
export class MessageConverterAdapter
	extends ApplicationAdapter
	implements MessageConverterPort
{
	public asMessageEntity(output: MessageOutput): Message {
		if (!output) {
			return null;
		}
		return new Message(
			output.id,
			new Date(output.creationTimestamp),
			output.content,
			output.moduleId,
			output.authorId,
			output.documentId,
			output.visioSessionId,
			output.updateTimestamp,
			output.participantsId || []
		);
	}

	public asMessagesEntities(outputs: MessageOutput[]): Message[] {
		return reject(outputs, isNil).map((output) => this.asMessageEntity(output));
	}
}
